import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdmindecryptPage } from './decrypt.page';

const routes: Routes = [
  {
    path: '',
    component: AdmindecryptPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdmindecryptPageRoutingModule {}
